export default {
  label: {
    open: 'Abertura',
    waiting: 'Em espera',
    answer: 'Resposta',
    finished: 'Finalização',
  },
  date: {
    month: 'mês',
    day: 'dia',
    hour: 'hora',
    minute: 'minuto',
    second: 'segundo',
    default: '0 dias 0 horas',
  },
};
